export default __webpack_public_path__ + "static/SSSpyView_screenshot-2@mob2x-8b59d815d48c06bb03f5c9d125817a07.webp";